import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=6350c2c3&scoped=true&"
import script from "./CustomMenu.vue?vue&type=script&lang=js&"
export * from "./CustomMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=6350c2c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350c2c3",
  null
  
)

export default component.exports